import { MapDeserializer } from "@/util/MapDeserializer";
export class CartItemDto {
    productId;
    dateFrom = new Date();
    dateTo = new Date();
    resourceReservations = {};
    grossPrices = new Map();
    grossPriceAdjustments = {};
    timeslotId;
    constructor(cartItem) {
        this.productId = cartItem.product.id;
        this.dateFrom = cartItem.dateFrom;
        this.dateTo = cartItem.dateTo;
        this.resourceReservations = cartItem.resourceReservations;
        this.grossPrices = cartItem.prices;
        this.grossPriceAdjustments = cartItem.priceAdjustments;
        this.timeslotId = cartItem.selectedTimeslot?.id;
    }
    init(other) {
        Object.assign(this, other);
        this.grossPrices = MapDeserializer.deserializePriceAmountMap(other.grossPrices);
    }
}
